import { render, staticRenderFns } from "./contrEdit.vue?vue&type=template&id=4f8b04c6&scoped=true&"
import script from "./contrEdit.vue?vue&type=script&lang=tsx&"
export * from "./contrEdit.vue?vue&type=script&lang=tsx&"
import style0 from "./contrEdit.vue?vue&type=style&index=0&id=4f8b04c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b04c6",
  null
  
)

export default component.exports